import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getAgencyListByStatusFailure, getAgencyListByStatusSuccess } from '../../actions/agencyActions/getAgencyListByStatusActions';

function* getAgencyListByStatus({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAgencyListByStatus + payload.statusFilter,
            payload,
            isAuth: true,
        });
        yield put(getAgencyListByStatusSuccess({
            status: response?.data?.status,
            response: response?.data?.response,
            message: response?.data?.message,
        }));
    } catch (error) {
        yield put(getAgencyListByStatusFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message,
        }));
    }
}

function* getAgencyListByStatusSaga() {
    yield takeLatest(actionTypes.GET_AGENCY_LIST_BY_STATUS_REQUEST, getAgencyListByStatus);
}

export default getAgencyListByStatusSaga;
